<script lang="ts">
  import { prefectures } from '../../../components/Prefecture';
  import RepositoryFactory, {
    CONTRACT,
    CUSTOMER,
    SIM_EXCHANGE_DELIVERY
  } from '../../../repositories/RepositoryFactory';
  import Loading from '../../loader.svelte';
  import { push } from 'svelte-spa-router';
  import { loginUser } from '../../../components/auth/LoginUser';
  import { getContext } from 'svelte';
  const { close }: any = getContext('simple-modal');

  const simsizeList = [
    { code: 'MICRO', name: 'マイクロSIM' },
    { code: 'NANO', name: 'ナノSIM' },
    { code: 'STANDARD', name: '標準SIM' }
  ];

  let sei = '',
    mei = '',
    zipcode = '',
    prefectureCode = '',
    city = '',
    street = '',
    building = '',
    simsizeCode = '',
    beforeSimsizeCode = '';
  let display: 'INPUT' | 'CONFIRM' | 'COMPLETE' = 'INPUT';
  let promise = getApi();

  async function getApi() {
    const contractRepository = RepositoryFactory[CONTRACT];
    const customerRepository = RepositoryFactory[CUSTOMER];

    await Promise.all([contractRepository.getContract(), customerRepository.getCustomerAddressInfo()])
      .then((res) => {
        beforeSimsizeCode = res[0].simsizeCodePremium;
        simsizeCode = beforeSimsizeCode;
        sei = res[1].customerSei;
        mei = res[1].customerMei;
        zipcode = res[1].zipcode;
        prefectureCode = res[1].prefectureCode;
        city = res[1].city;
        street = res[1].street;
        building = res[1].building;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
        } else {
          alert('エラーが発生しました。');
        }
        return false;
      });
  }

  function goConfirm() {
    display = 'CONFIRM';
  }

  function goBack() {
    display = 'INPUT';
  }

  function goComplete() {
    const simRepository = RepositoryFactory[SIM_EXCHANGE_DELIVERY];
    simRepository
      .requestSimExchangeDeliveryForPremium({
        simsizeCode
      })
      .then((res) => {
        display = 'COMPLETE';
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('SIM交換依頼に失敗しました。');
        }
      });
  }

  function closeModal() {
    if (display === 'COMPLETE') {
      location.reload();
    } else {
      close();
    }
  }
</script>

<div class="h-auto p-6 bg-white w-full m-auto">
  {#await promise}
    <Loading />
  {:then}
    <div class="flex justify-between mb-10">
      <div class=" text-gray-700">
        <h1 class="text-2xl font-bold">SIM交換</h1>
      </div>
    </div>

    <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
      <div class="flex flex-col">
        {#if display === 'INPUT'}
          <div class="items-center min-w-full">以下の内容でSIM交換依頼を行います。</div>

          <div class="flex-1 mt-4 mb-10">
            <div class="item">
              <div class="item-title">配送先顧客名：</div>
              <div>{sei + mei}</div>
            </div>
            <div class="item mt-2">
              <div class="item-title">配送先住所：</div>
              <div class="break-words">
                〒{zipcode}
                {prefectures.filter((prefecture) => prefecture.id === prefectureCode)[0].name}{city}{street}
                {building ?? ''}
              </div>
            </div>
            <div class="item mt-2">
              <div class="item-title">現在のSIMサイズ：</div>
              <div>
                {simsizeList.find((v) => v.code === beforeSimsizeCode).name}
              </div>
            </div>
            <div class="item mt-2">
              <div class="item-title">交換後のSIMサイズ：</div>
              <div>
                <select class="form-select text-sm p-1" bind:value={simsizeCode}>
                  {#each simsizeList as simsize}
                    <option value={simsize.code}>
                      {beforeSimsizeCode === simsize.code ? '変更なし' : simsize.name}
                    </option>
                  {/each}
                </select>
              </div>
            </div>
          </div>
        {:else if display === 'CONFIRM'}
          <div class="items-center min-w-full">以下の内容でSIM交換依頼を行います。</div>

          <div class="flex-1 mt-4 mb-10">
            <div class="item">
              <div class="item-title">配送先顧客名：</div>
              <div>{sei + mei}</div>
            </div>
            <div class="item mt-2">
              <div class="item-title">配送先住所：</div>
              <div class="break-words">
                〒{zipcode}
                {prefectures.filter((prefecture) => prefecture.id === prefectureCode)[0].name}{city}{street}
                {building ?? ''}
              </div>
            </div>
            <div class="item mt-2">
              <div class="item-title">現在のSIMサイズ：</div>
              <div>
                {simsizeList.find((v) => v.code === beforeSimsizeCode).name}
              </div>
            </div>
            <div class="item mt-2">
              <div class="item-title">交換後のSIMサイズ：</div>
              <div>
                {simsizeList.find((v) => v.code === simsizeCode).name}
              </div>
            </div>
          </div>
        {:else}
          <div class="flex-1 mt-4 mb-10">
            <div class="item mb-10">SIM交換依頼を受け付けました。</div>
          </div>
        {/if}

        <div class="flex-1 mb-10">
          <div class="shadow rounded bg-gray-200 p-4">
            <slot class="text-sm">
              注意事項 <br />
              <span>
                ※SIM再発行手続きには交換手数料(3,300円)が必要となります。<br />
                ※配送先は、ご契約者住所への限定配送となります。<br />
                ※お引っ越し等により住所が変更になっている場合などは、交換手続きの前にマイページより別途契約名義人等の変更手続きを行ってください
              </span>
            </slot>
          </div>
        </div>

        <div class="flex-1">
          <div class="flex flex-col justify-items-center items-center">
            <div class="flex-1">
              {#if display === 'INPUT'}
                <button
                  class="bg-green-400 rounded hover:bg-green-500 text-white focus:outline-none px-14 py-2"
                  on:click|once={goConfirm}
                >
                  次へ
                </button>
              {:else if display === 'CONFIRM'}
                <button
                  class="bg-gray-300 rounded hover:bg-gray-400 text-gray-500 focus:outline-none px-10 py-2"
                  on:click={goBack}>戻る</button
                >
                <button
                  class="bg-green-400 rounded hover:bg-green-500 text-white focus:outline-none px-14 py-2 ml-5"
                  on:click|once={goComplete}
                >
                  OK
                </button>
              {:else}
                <button
                  class="bg-gray-300 rounded hover:bg-gray-400 text-gray-500 focus:outline-none px-10 py-2"
                  on:click={closeModal}>閉じる</button
                >
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  {/await}
</div>

<style lang="postcss">
  .item {
    display: inline-flex;
    justify-items: center;
    align-items: center;
    min-width: 100%;
  }
  .item-title {
    min-width: 10rem;
  }
</style>
